import {FormField, FormFieldType, SelectionOption} from 'lionheartland';
import {ENSesMessageType} from '../../enums';

export class PutSesMessageFormFields {

    public data: FormField
    public messageType: FormField

    constructor() {

        this.data = new FormField(
          'data',
          'Data',
          null,
          FormFieldType.text,
          false,
        )
        this.messageType = new FormField(
          'messageType',
          'Message type',
          null,
          FormFieldType.enumeration,
          false,
        )
        this.messageType.enumeration = ENSesMessageType

    }
}

const fields = new PutSesMessageFormFields()

export const putSesMessageFormFieldOptions: {[key: string]: FormField} = {
  data: fields.data,
  messageType: fields.messageType,
};